import React from 'react'

import { FilterDropdown } from '@components/common/FilterDropdown'
import { Checkbox } from '@fourthwall/components'
import { useFormik } from '@fourthwall/utils/dist/formik'

import * as S from './styled'
import type { FilterDropdownViewProps, FilterFormValues } from './types'

export const PostsFilterView = ({
  types,
  initialValues,
  filterActive,
  onSubmit,
  onReset,
}: FilterDropdownViewProps) => {
  const formik = useFormik<FilterFormValues>({
    initialValues,
    onSubmit,
    enableReinitialize: true,
  })

  const handleReset = () => {
    formik.resetForm()
    onReset()
  }

  const handleCheckboxGroupChange = (checked: boolean, value: string, name: string) => {
    const fieldValue = checked
      ? [...(formik.values as any)[name], value]
      : (formik.values as any)[name].filter((v: any) => v !== value)

    formik.setFieldValue(name, fieldValue)
  }

  const renderTypes = () =>
    !!types?.length && (
      <S.FiltersGroup>
        <FilterDropdown.GroupTitle title="Post type" />
        <S.CheckboxGroup role="group">
          {types.map((option) => (
            <Checkbox
              native
              key={option.value}
              label={option.label}
              value={option.value}
              checked={formik.values.types.includes(option.value)}
              onValueChange={(checked) => handleCheckboxGroupChange(checked, option.value, 'types')}
            />
          ))}
        </S.CheckboxGroup>
      </S.FiltersGroup>
    )

  return (
    <FilterDropdown
      content={<form>{renderTypes()}</form>}
      activityIndicator={filterActive}
      onSubmit={formik.handleSubmit}
      onReset={handleReset}
    />
  )
}
